import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { $host } from "../../../../http";
import ButtonBase from "../../components/buttons/ButtonBase";
import AddHomeworkForm from "../../components/forms/AddHomework";

const HomeworkEditor = () => {
    const { homework_id } = useParams();
    const [questions, setQuestions] = useState([]);
    const [isAdding, setIsAdding] = useState(false);

    useEffect(() => {
        fetchQuestions();
    }, []);

    const fetchQuestions = async () => {
        try {
            const response = await $host.get(`/api/students/homeworks/${homework_id}/questions`, { withCredentials: true });

            if (response.data.body && Array.isArray(response.data.body)) {
                setQuestions(response.data.body); // Теперь передаём весь объект, включая `question`
            } else {
                setQuestions([]);
            }
        } catch (error) {
            console.error("Ошибка загрузки вопросов:", error);
        }
    };



    return (
        <div className="p-6 bg-gray-50 rounded-lg">
            <h2 className="text-2xl font-semibold mb-6 text-gray-800">Редактирование домашнего задания</h2>

            <div className="flex gap-4 mb-6">
                <ButtonBase className="bg-green-600 text-white px-6 py-3 rounded-lg" onClick={() => setIsAdding(true)}>
                    + Добавить вопрос
                </ButtonBase>
            </div>

            {isAdding && (
                <AddHomeworkForm
                    hwId={homework_id}
                    closeForm={() => setIsAdding(false)}
                    updateQuestions={fetchQuestions}
                />
            )}

            <h3 className="text-lg font-semibold mt-6 mb-4">Список вопросов</h3>
            <ul className="space-y-4">
                {questions.map((q, idx) => (
                    <AddHomeworkForm
                        key={q.id}
                        hwId={homework_id}
                        data={q}
                        idx={idx}
                        updateQuestions={fetchQuestions}
                        closeForm={() => setIsAdding(false)}
                    />
                ))}
            </ul>

        </div>
    );
};

export default HomeworkEditor;
